import { defineMessages } from "react-intl";

export enum CampaignPageType {
  title = "CampaignPageType.title",
  titleEdit = "CampaignPageType.titleEdit",

  promptStepError = "CampaignPageType.promptStepError",
  savingError = "CampaignPageType.savingError",

  randomDelivery = "CampaignPageType.randomDelivery",
  specificDate = "CampaignPageType.specificDate",

  videoMessage = "CampaignPageType.videoMessage",
  publishBtn = "CampaignPageType.publishBtn",
  titlePlaceholder = "CampaignPageType.titlePlaceholder",
  messagePlaceholder = "CampaignPageType.messagePlaceholder",

  saveDraftBtn = "CampaignPageType.saveDraftBtn",
  nextBtn = "CampaignPageType.nextBtn",
  backBtn = "CampaignPageType.backBtn",

  saveUnPublishBtn = "CampaignPageType.saveUnPublishBtn",

  cancelBtn = "CampaignPageType.Cancel",
  unknownError = "CampaignPageType.unknownError",
  savedMessage = "CampaignPageType.savedMessage",

  saveCampaignAlert = "CampaignPageType.saveCampaignAlert",
  yesBtn = "CampaignPageType.yesBtn",
  noBtn = "CampaignPageType.noBtn",
}

export const en = {
  [CampaignPageType.title]: "Create Campaign",
  [CampaignPageType.titleEdit]: "Edit your campaign",
  [CampaignPageType.promptStepError]: "You must select at least 1 prompt",
  [CampaignPageType.savingError]: "Error creating a new campaign",

  [CampaignPageType.randomDelivery]: "Random Delivery Date",
  [CampaignPageType.specificDate]: "Specific Date",

  [CampaignPageType.videoMessage]: "Instructional Video (optional)",
  [CampaignPageType.titlePlaceholder]: "Enter title",
  [CampaignPageType.messagePlaceholder]: "Write Message",

  [CampaignPageType.saveDraftBtn]: "Save as draft",

  [CampaignPageType.nextBtn]: "Next",
  [CampaignPageType.cancelBtn]: "Cancel",
  [CampaignPageType.backBtn]: "Back",
  [CampaignPageType.publishBtn]: "Publish Campaign",

  [CampaignPageType.saveUnPublishBtn]: "Save & Unpublish",

  [CampaignPageType.savedMessage]: "Prompt saved!",
  [CampaignPageType.unknownError]: "Unknown Error.",

  [CampaignPageType.saveCampaignAlert]: "Do you want to save this campaign?",

  [CampaignPageType.yesBtn]: "Yes",
  [CampaignPageType.noBtn]: "No",
};

export const descriptors = defineMessages({
  [CampaignPageType.title]: {
    id: CampaignPageType.title,
    defaultMessage: en[CampaignPageType.title],
    description: "-",
  },
  [CampaignPageType.titleEdit]: {
    id: CampaignPageType.titleEdit,
    defaultMessage: en[CampaignPageType.titleEdit],
    description: "-",
  },
  [CampaignPageType.randomDelivery]: {
    id: CampaignPageType.randomDelivery,
    defaultMessage: en[CampaignPageType.randomDelivery],
    description: "-",
  },
  [CampaignPageType.specificDate]: {
    id: CampaignPageType.specificDate,
    defaultMessage: en[CampaignPageType.specificDate],
    description: "-",
  },
  [CampaignPageType.promptStepError]: {
    id: CampaignPageType.promptStepError,
    defaultMessage: en[CampaignPageType.promptStepError],
    description: "-",
  },

  [CampaignPageType.savingError]: {
    id: CampaignPageType.savingError,
    defaultMessage: en[CampaignPageType.savingError],
    description: "-",
  },
  [CampaignPageType.videoMessage]: {
    id: CampaignPageType.videoMessage,
    defaultMessage: en[CampaignPageType.videoMessage],
    description: "-",
  },
  [CampaignPageType.publishBtn]: {
    id: CampaignPageType.publishBtn,
    defaultMessage: en[CampaignPageType.publishBtn],
    description: "-",
  },
  [CampaignPageType.messagePlaceholder]: {
    id: CampaignPageType.messagePlaceholder,
    defaultMessage: en[CampaignPageType.messagePlaceholder],
    description: "-",
  },
  [CampaignPageType.titlePlaceholder]: {
    id: CampaignPageType.titlePlaceholder,
    defaultMessage: en[CampaignPageType.titlePlaceholder],
    description: "-",
  },
  [CampaignPageType.saveDraftBtn]: {
    id: CampaignPageType.saveDraftBtn,
    defaultMessage: en[CampaignPageType.saveDraftBtn],
    description: "-",
  },
  [CampaignPageType.cancelBtn]: {
    id: CampaignPageType.cancelBtn,
    defaultMessage: en[CampaignPageType.cancelBtn],
    description: "-",
  },
  [CampaignPageType.unknownError]: {
    id: CampaignPageType.unknownError,
    defaultMessage: en[CampaignPageType.unknownError],
    description: "-",
  },

  [CampaignPageType.nextBtn]: {
    id: CampaignPageType.nextBtn,
    defaultMessage: en[CampaignPageType.nextBtn],
    description: "-",
  },

  [CampaignPageType.backBtn]: {
    id: CampaignPageType.backBtn,
    defaultMessage: en[CampaignPageType.backBtn],
    description: "-",
  },

  [CampaignPageType.saveUnPublishBtn]: {
    id: CampaignPageType.saveUnPublishBtn,
    defaultMessage: en[CampaignPageType.saveUnPublishBtn],
    description: "-",
  },
  [CampaignPageType.savedMessage]: {
    id: CampaignPageType.savedMessage,
    defaultMessage: en[CampaignPageType.savedMessage],
    description: "-",
  },

  [CampaignPageType.saveCampaignAlert]: {
    id: CampaignPageType.saveCampaignAlert,
    defaultMessage: en[CampaignPageType.saveCampaignAlert],
    description: "-",
  },

  [CampaignPageType.yesBtn]: {
    id: CampaignPageType.yesBtn,
    defaultMessage: en[CampaignPageType.yesBtn],
    description: "-",
  },
  [CampaignPageType.noBtn]: {
    id: CampaignPageType.noBtn,
    defaultMessage: en[CampaignPageType.noBtn],
    description: "-",
  },
});
